
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M10.495 3.75a.464.464 0 00-.328.134v.001L2.53 11.528a.75.75 0 11-1.062-1.06l7.638-7.645.002-.002a1.964 1.964 0 012.778.008v.001l7.643 7.637a.75.75 0 01-1.06 1.061l-7.644-7.639-.003-.002a.464.464 0 00-.328-.137z"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M4.428 7.816a.75.75 0 01.75.75v8.967h10.643V8.57a.75.75 0 011.5 0v9.713a.75.75 0 01-.75.75H4.428a.75.75 0 01-.75-.75V8.566a.75.75 0 01.75-.75z"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M8.253 12.393a3.179 3.179 0 015.426 2.247v3.643a.75.75 0 11-1.5 0V14.64a1.679 1.679 0 00-3.357 0v3.643a.75.75 0 11-1.5 0V14.64c0-.843.335-1.651.93-2.247z"}})])
          )
        }
      }
    